@if (!submenuDisabled) {
  <lib-navigation-sub-menu
    [mayHaveCover]="mayHaveCover$ | async"
    [showMobileMenu]="shouldOpenSubNavigation$"
    >
    <div body>
      <h1 [ngClass]="{ fakeTitle: willHaveTitle }" class="mat-h1 submenu-title">
        <ng-content select="[title]"></ng-content>
      </h1>
      <div class="subtitle">
        <ng-content select="[subTitle]"></ng-content>
      </div>
      <div (cdkObserveContent)="mayHaveCover$.next(true)" class="cover">
        <ng-content select="lib-cover-view"></ng-content>
      </div>
      <lib-scrollbar [margin]="20">
        <ng-content select="[bareContent]"></ng-content>
        <mat-list>
          <ng-content select="[mat-list-item]"></ng-content>
        </mat-list>
      </lib-scrollbar>
    </div>
    <div bottom>
      <ng-content select="[bottom]"></ng-content>
    </div>
  </lib-navigation-sub-menu>
}
<div
  [ngClass]="{
    isFull: isFullContainer$ | async,
    noPadding: isNoPadding$ | async
  }"
  class="container"
  >
  @if (hasSave$ | async) {
    <div class="save">
      <span #saveButton data-vg="NavigationSave">
        @if (!(isMobile$ | async)) {
          <lib-button
            (click)="navigationService.savePage()"
            [isLoading$]="navigationService.watchSaveState"
            >zapisz</lib-button
            >
          } @else {
            <lib-fab-save
              (click)="navigationService.savePage()"
              [isLoading$]="navigationService.watchSaveState"
              >save</lib-fab-save
              >
            }
          </span>
        </div>
      }
      <div class="content">
        <ng-content select="[content]"></ng-content>
      </div>
    </div>
